import React from 'react'
import * as C from "../componentsM/index";

const Admission = () => {
    return (
        <>

            <C.Hero title={"ADMISSION PROCESS"} image={"/hero/24.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p className='font-semibold'>Parents are required to submit the following documents to the Admissions Office. Please note that all documents must be completed in English and/or translated into English. These include:</p>

                    <h1 className='text-myBlue font-bold text-xl md:text-3xl'>Stage I: Documentation</h1>


                    <p>The Admissions Office acknowledges receipt of the application form, communicates any omissions in the admissions package and schedules a placement assessment. The application can only proceed if ALL the accompanying documents have been included. Following the placement test, an interview will be scheduled for prospective parents and applicant(s) with the respective department’s Admissions Committee. The Admissions Committee in each programme consists of the Registrar, Programme Coordinator and a teacher.</p>

                    <figure className='mx-auto md:w-[80%]'>
                        <img src="/admission/1.jpg" alt='Stage one admission documentation requirements' className='w-full h-full object-contain' />
                    </figure>


                    <h1 className='text-myBlue font-bold text-xl md:text-3xl'>Stage II: Evaluation</h1>

                    <p>Following the review of the submitted documents, an evaluation date will be forwarded by the Admissions Office to the parent. The following placement assessments will be administered:</p>

                    <figure className='mx-auto md:w-[80%]'>
                        <img src="/admission/2.jpg" alt='Stage two admission evaluation details' className='w-full h-full object-contain' />
                    </figure>

                    <p>*Language Acquisition placements tests are administered after admission to ascertain the proficiency of the candidate in the subject.</p>


                    <h1 className='text-myBlue font-bold text-xl md:text-3xl'>Stage III: Interview</h1>

                    <p>The placement assessments, the Admissions Committee will conduct formal interviews with both the parents as well as the applicant.</p>


                    <figure className='mx-auto md:w-[80%]'>
                        <img src="/admission/3.jpg" alt='Stage three admission interview details' className='w-full h-full object-contain' />
                    </figure>


                    <h1 className='text-myBlue font-bold text-xl md:text-3xl'>Stage IV: Decision of the Admissions Committee</h1>


                    <p>The Admissions Committee will evaluate the student and make a decision on grade placement with the best interest of the student in mind. This will be determined by the age appropriate level, previous academic records, recommendations, placement assessments and the interview. This decision will be communicated to the applicant immediately after the interview.</p>


                    <p>Upon approval of the Admissions Committee, a letter of offer from the Registrar will be received by the applicant. A welcome package and a tuition invoice that outlines all the associated costs of enrolment, will accompany this letter. Accepted offers will require the applicant to complete payment of the invoice within five working days.</p>

                    <h1 className='text-myBlue font-bold text-xl md:text-3xl'>Stage V: Further Evaluation</h1>

                    <p>If it is determined that there is insufficient evidence to make a firm decision, applicants will receive a written notification from the Admissions Office outlining the additional information required, as well as an expected timeline for the completion of the process. This may involve additional interviews or evaluation with our school specialists, or contact with the applicant’s previous school.</p>


                    <h1 className='text-myBlue font-bold text-xl md:text-3xl'>Stage VI: Fee Structure</h1>


                    <p>The application fee is payable after stage IV. In the case of a positive decision by the Admissions Committee, an admission’s package will be released to the parent. This will include instructions of paying the required admission’s related fees. The payment of this fee will secure the admission of the child and thus bring the admission’s process to an end. Complete payment of the invoice must take place within one week.</p>


                    <figure className='mx-auto md:w-[80%]'>
                        <img src="/admission/4.jpg" alt='Stage six admission fee structure' className='w-full h-full object-contain' />
                    </figure>

                    <p>Admission Deadlines</p>


                    <div>
                        <p>Age 3 to 16 Years (Junior and Middle School):</p>
                        <p>March 31</p>
                        <p>Early deadline for admission</p>
                        <p>Deadline for scholarship</p>
                    </div>


                    <div>
                        <p>April 30</p>
                        <p>Final deadline for admission</p>
                    </div>

                    <div>
                        <p>Age 16+ Years (High School)</p>
                        <p>May 31</p>

                        <p>Early deadline for admission</p>
                        <p>Deadline for scholarship</p>
                    </div>


                    <div>   
                        <p>August 15</p>
                        <p>Final deadline for admission</p>
                    </div>

                </div>


            </section>

        </>
    )
}
export default Admission